import generateReport from "../../services/AxiosReportService";
import api from "../../services/AxiosService";

export const generateAccountGl = (data) => {
    return generateReport("post", "api/book-entry-details/ledger-account/generate", "", data)
};

export const generateLedgerBranchReport = (data) => {
    return generateReport("post", "api/book-entry-details/ledger-branch/generate", "", data)
};

export const getAllLedgerHeaders = () => {
    return api("get", "api/ledger-header/headers", "", null);
};

export const generateLedgerDistrictReport = (data) => {
    return generateReport("post", "api/book-entry-details/district-general-ledger", "", data)
};

export const generateLedgerDistrictWiseReport = (data) => {
    return generateReport("post", "api/book-entry-details/ledger-district/generate", "", data)
};

export const generateLedgerBranchWiseReport = (data) => {
    return generateReport("post", "api/book-entry-details/book-entry-list", "", data)
};

export const getDivAreaBranches = () => {
    return api("get", "api/div-branch/list", null);
}

export const getAllDistrict = () => {
    return api("get", "api/district/list", "", null);
};

export const getAllBranchesByDistrictName = (data) => {
    return api("get", "api/branch-by-district-name", data, null);
}
export const getAllTrailBalance = (data) => {
    return generateReport("post", "api/book-entry-details/ledger-trail-balance", "", data);
}

export const generateLedgerBranchWiseReportDistrict = (data) => {
    return generateReport("post", "api/book-entry-details/book-entry-list-by-district", "", data)
};

export const getDistrictDivisionalBranchDetails = () => {
    return api("get", "api/district-divisional-branch", "", null)
}

export const getAllOpeningBalances = (data) => {
    return api("post", "api/book-entry-details/general-ledger/opening-balance", "", data);
}

export const getAllBookEntryList = (data) => {
    return api("post", "api/book-entry/entries", "", data);
}

export const getAllReversedData = (data) => {
    return api("post", "api/book-entry/reversed-transactions", "", data);
}

export const monitorBookEntry = (param) => {
    return api("post", "api/book-entry", param, null);
}

